import React, { useImperativeHandle, forwardRef, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  createStyles,
} from "@material-ui/core";

import {
  ATALHO_VOLTAR,
  ATALHO_AVANCAR,
  SECONDARY_COLOR,
} from "../../../../../utils";
import { AutoCompleteLocal } from "../../../../../components";

const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const ESC_ACTION = "Escape";

const options = [
  {
    id: "cancelamento-debito",
    nome: "Cancelamento Débito",
  },
  {
    id: "cancelamento-credito",
    nome: "Cancelamento Crédito",
  },
  {
    id: "cancelamento-pix",
    nome: "Cancelamento Pix",
  },
];

const useStyles = makeStyles((theme) =>
  createStyles({
    action: {
      display: "flex",
      justifyContent: "space-between",
    },
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    button: {
      color: "white",
      backgroundColor: theme.palette.secondary.main,
    },
    disabledButton: {
      backgroundColor: "red",
    },
  })
);

const DialogoTipoCredito = forwardRef(
  ({ handleFinalizar = () => {}, handleCancelar = () => {} }, ref) => {
    const [open, setOpen] = useState(false);
    const [tipoCancelamento, setTipoCancelamento] = useState(options[0]);
    const classes = useStyles();

    useImperativeHandle(ref, () => ({
      handleOpen() {
        setTipoCancelamento(options[0]);
        setOpen(true);
      },
    }));

    const erro = tipoCancelamento ? "" : "Obrigatório Preencher este Campo";

    function handleActions(action) {
      switch (action) {
        case FECHAR_VENDA_ACTION: {
          handleFinalizar(tipoCancelamento.id);
          setOpen(false)
          break;
        }
        case CANCELAR_VENDA_ACTION: {
          handleCancelar();
          setOpen(false)
          break;
        }
        case ESC_ACTION: {
          handleCancelar();
          setOpen(false)
          break;
        }
        default:
          break;
      }
      
    }

    function handleKey(keyCode, keyName) {
      handleActions(keyName);
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCancelar}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
          disableEscapeKeyDown
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              color: "white",
              backgroundColor: SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {`Tipo de Cancelamento`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: "20px 10px",
            }}
          >
            <div>
              <AutoCompleteLocal
                handleEnter={() => {handleActions(FECHAR_VENDA_ACTION);}}
                label=""
                handleKey={handleKey}
                value={tipoCancelamento}
                onChangeLocal={(value) => {
                  setTipoCancelamento(value);
                }}
                error={erro !== ""}
                helperText={erro}
                campo="nome"
                options={options}
                variant="standard"
                autoFocus
              />
            </div>
          </DialogContent>
          <DialogActions className={classes.action}>
            <Button
              onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`Cancelar (${CANCELAR_VENDA_ACTION})`}
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => handleActions(FECHAR_VENDA_ACTION)}
              tabindex="-1"
              disabled={tipoCancelamento ? false : true}
            >
              {`Avançar (${FECHAR_VENDA_ACTION})`}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default DialogoTipoCredito;
